<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/home">首页</shBreadItem>
      <shBreadItem to="/tests?maID=055618">题库</shBreadItem>
      <shBreadItem v-if="firstlist" :to="`/video?firstCate=${menulist.chID}`">{{
        firstlist.chName
      }}</shBreadItem>
      <shBreadItem
        v-if="secondlist"
        :to="`/video?firstCate=${menulist.chID}&secondCate=${menulist.coID}`"
        >{{ secondlist.coName }}</shBreadItem
      >
      <shBreadItem v-if="testsData.length"
        ><div class="bread">{{ testsData[0]?.testsName }}</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="video-detail"><TestsDesc :testsData="testsData" /></div>
  <div class="player-detail">
    <div class="player-desc">
      <ShTabs v-model="activeName">
        <ShTabsPanel label="题库详情" name="testsDesc">
          <TestsImg :testsData="testsData" />
        </ShTabsPanel>
        <ShTabsPanel label="考试大纲" name="testsOutline">
          <VideoOutline :videoData="videoData" />
        </ShTabsPanel>
        <ShTabsPanel label="备考建议" name="testsAdvice">
          <VideoAdvice :videoData="videoData" />
        </ShTabsPanel>
      </ShTabs>
    </div>
    <div class="player-reco">
      <VideoReCommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { findVideoRecommand } from "@/api/video";
import { findTestsDetail } from "@/api/tests";
import TestsImg from "./components/tests-img.vue";
import TestsDesc from "./components/tests-desc.vue";
import VideoAdvice from "../video-detail/compontents/video-advice.vue";
import VideoOutline from "../video-detail/compontents/video-outline.vue";
import VideoReCommend from "@/components/video-recommend.vue";
import { useRouter, useRoute } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    TestsImg,
    TestsDesc,
    VideoAdvice,
    VideoOutline,
    VideoReCommend,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const activeName = ref("testsDesc");
    const testsData = ref([]);
    const videoData = ref([]);
    const VideoReCommend = ref([]);

    //console.log(typeof route.query.clID);

    findTestsDetail(route.query.id)
      .then((data) => {
        //console.log(data);
        videoData.value = data;
        testsData.value = data.map((item) => {
          return {
            id: item._id,
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            testsCoverImg: "/web/" + item.testsCoverImg,
            testsDescImg: "/web/" + item.testsDescImg,
            testsName: item.testsName,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
    const clID = route.query.clID.split(",");
    //console.log(clID);
    findVideoRecommand(clID)
      .then((data) => {
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "/web/" + item.leImg,
            coverImg: "/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
    //面包屑获得的数据
    const menulist = computed(() => {
      return store.state.category.list.find(
        (item) => item.clID === parseInt(clID)
      );
    });
    //console.log(menulist);
    const secondlist = computed(() => {
      return store.state.category.list.find(
        (item) => item.coID === parseInt(menulist.value.coID)
      );
    });
    const firstlist = computed(() => {
      return store.state.category.list.find(
        (item) => item.chID === parseInt(menulist.value.chID)
      );
    });
    //console.log(firstlist);
    return {
      activeName,
      testsData,
      videoData,
      VideoReCommend,
      menulist,
      secondlist,
      firstlist,
    };
  },
};
</script>

<style lang="less" scoped>
.news-bread {
  background: @shColor;
  //margin-bottom: 15px;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.video-detail {
  width: 1240px;
  margin: 0 auto;
}
.player-detail {
  display: flex;
  justify-content: space-between;
  width: 1240px;
  margin: 50px auto;

  .player-desc {
    width: 850px;
    border-radius: 5px;
    background: #fff;
  }
  .player-reco {
    width: 350px;
    border-radius: 5px;
    background: #fff;
  }
}
</style>
